// extracted by mini-css-extract-plugin
module.exports = {"placeholderContainer":"Placeholder_placeholderContainer__KTi38","horizontal":"Placeholder_horizontal__2s21Y"};